/**
 * we suggest using the "domain/action" convention for readability.
 */

 /** Auth */
 export const SET_USER = 'auth/login'
 export const UNSET_USER = 'auth/reset'
 export const SET_LOGIN_ERROR = 'auth/error'
 
 /** unenrolled student */
 export const SET_STUDENT_INFO = 'student/info'
 export const SET_UNENROLLED_STUDENT_DOCUMENTS = 'unenrolledStudent/setDocuments'
 export const BEGINNING_REQUEST = 'unenrolledStudent/loading'
 export const ERROR_DOCUMENT_REQUEST = 'unenrolledStudent/error'
 export const DOCUMENT_UPLOADED = 'unenrolledStudent/uplodingDocument'

 /** export excel document */
 export const SET_PARAM = 'exportDocument/setParameter'

/** modal */
 export const SET_SHOW_MODAL = 'modal/show'
 export const SET_HIDE_MODAL = 'modal/hide'

 export const SET_UNENROLLED_STUDENT_INFO_LOADING = 'studentUnenrolledInfomation/loading'
 export const SET_UNENROLLED_STUDENT_INFO_ERROR = 'studentUnenrolledInfomation/error'
 export const SET_UNENROLLED_STUDENT_INFO = 'studentUnenrolledInfomation/setAllInformation'
 export const SET_UNENROLLED_STUDENT_INFO_RESET= 'studentUnenrolledInfomation/reset'

 /** periods list */
 export const SET_PERIODS = 'periods/setAll'
 export const DELETE_PERIOD = 'periods/delete'

/** selected period */
 export const SET_SELECTED_PERIOD_INFO_LOADING = 'selectedPeriodInformation/loading'
 export const SET_SELECTED_PERIOD_INFO_ERROR = 'selectedPeriodInformation/error'
 export const SET_SELECTED_PERIOD_INFO = 'selectedPeriodInformation/setAllInformation'
 export const SET_SELECTED_PERIOD_INFO_RESET= 'selectedPeriodInformation/reset'